import { gql } from '@apollo/client';

export const PLAYER_SEASON_STAT_FRAGMENT = gql`
  fragment PlayerSeasonStats on players {
    attendance_aggregate(
      where: { schedule: { seasonId: { _eq: $seasonId } } }
    ) {
      aggregate {
        count
      }
      nodes {
        schedule {
          awayGoalie
          homeGoalie
        }
      }
    }
    goals_aggregate(where: { schedule: { seasonId: { _eq: $seasonId } } }) {
      aggregate {
        count
      }
    }
    primaryAssist_aggregate(
      where: { schedule: { seasonId: { _eq: $seasonId } } }
    ) {
      aggregate {
        count
      }
    }
    secondaryAssist_aggregate(
      where: { schedule: { seasonId: { _eq: $seasonId } } }
    ) {
      aggregate {
        count
      }
    }
    penalties_aggregate(where: { schedule: { seasonId: { _eq: $seasonId } } }) {
      aggregate {
        sum {
          minutes
        }
      }
    }
  }
`;
